import { TBillingHistoryInitialState } from "./billingHistory.types";

export const initialState: TBillingHistoryInitialState = {
  data: [],
  isLoading: false,
  error: null,
  hasMore: false,
  total: 0,
};
